import { useLayoutEffect, useEffect } from 'react'

const scrollLockClassName = 'scroll-lock'

export default (state) => {
  const canUseDOM = typeof window !== 'undefined'
  const useIsomorphicLayoutEffect = canUseDOM ? useLayoutEffect : useEffect

  useIsomorphicLayoutEffect(() => {
    const mainElement = document.querySelector('main')
    if (!mainElement) return

    // Get original main overflow
    const originalStyleMain = window.getComputedStyle(mainElement).overflow
    const originalStyleRoot = window.getComputedStyle(document.documentElement).overflow

    if (state) {
      // Prevent scrolling on mount
      document.documentElement.style.overflow = 'hidden'
      mainElement.classList.add(scrollLockClassName)
    } else {
      mainElement.style.overflow = originalStyleMain
      document.documentElement.style.overflow = originalStyleRoot
      mainElement.classList.remove(scrollLockClassName)
    }

    // Re-enable scrolling when component unmounts
    return () => {
      mainElement.style.overflow = originalStyleMain
      document.documentElement.style.overflow = originalStyleRoot
      mainElement.classList.remove(scrollLockClassName)
    }
  }, [state]) // Empty array ensures effect is only run on mount and unmount
}
